<template>
    <!--图片组件, 图片点击可放大-->
    <div class="image-container" :class="{'no-zoom': !canZoom}">
        <img v-if="src" :src="src" @click="zoomImage" alt="img" />
        <img v-else src="../../images/default_image.png" @click="zoomImage" alt="img" />
        <!--黑色弹窗-->
        <el-dialog
            v-if="canZoom"
            :visible.sync="dialogVisible"
            fullscreen
            class="img-dialog"
            top="25vh"
        >
            <div class="big-image-container" @click="dialogVisible = false">
                <img v-if="src" :src="src" alt="img" />
                <img v-else src="../../images/default_image.png" alt="img" />
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
.image-container {
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    & > img {
        width: 100%;
        height: 100%;
        cursor: zoom-in;
    }
    .el-dialog {
        .big-image-container {
            box-sizing: border-box;
            height: 100%;
            & > img {
                max-width: 100%;
                height: 80%;
                display: block;
                cursor: zoom-out;
                margin: 0 auto;
            }
        }
    }

    &.no-zoom {
        img {
            cursor: default;
        }
    }
}
</style>
<style lang="scss">
.image-container {
    .el-dialog {
        background: transparent;
        .el-dialog__header {
            background: transparent;
        }
        .el-dialog__body {
            height: 100%;
        }
        .el-icon-close {
            font-size: 30px;
        }
    }
}
</style>

<script >
export default {
    props: {
        src: {
            type: String
        },
        canZoom: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            dialogVisible: false
        };
    },
    methods: {
        zoomImage() {
            if (this.canZoom) {
                this.dialogVisible = true;
                // 打点事件
                this.$emit('dot');
            }
        }
    }
};
</script>
